import './index.less'
import React from 'react'
import { Icon } from '@lightbeamai/design-system'

export const RolesColoredIcon: React.FC<React.HTMLProps<HTMLDivElement>> = ({
  children,
  ...rest
}) => {
  const propsWithMergedClassNames = { ...rest, className: `colored-icons ${rest?.className || ''}` }

  return <div {...propsWithMergedClassNames}>{children}</div>
}

export const GeneralIcon = () => {
  return (
    <RolesColoredIcon className="roles-general-icon">
      <Icon name="InfoSquare" color="#fff" width={16} height={16} />
    </RolesColoredIcon>
  )
}

export const FullAccessToIcon = () => {
  return (
    <RolesColoredIcon className="roles-full-access-to-objects-icon">
      <Icon name="CheckVerified02" color="#fff" width={16} height={16} />
    </RolesColoredIcon>
  )
}

export const CustomAccessToIcon = () => {
  return (
    <RolesColoredIcon className="roles-custom-access-to-icon">
      <Icon name="Settings04" color="#fff" width={16} height={16} />
    </RolesColoredIcon>
  )
}

export const ViewOnlyAccessToIcon = () => {
  return (
    <RolesColoredIcon className="roles-view-only-access-to-icon">
      <Icon name="Eye" color="#fff" width={16} height={16} />
    </RolesColoredIcon>
  )
}

export const EditRoleIcon = () => {
  return (
    <RolesColoredIcon className="roles-edit-role-icon">
      <Icon name="Lock01" color="#3E21EE" width={16} height={18} />
    </RolesColoredIcon>
  )
}
